import { render, staticRenderFns } from "./Licence.vue?vue&type=template&id=165c6f64&scoped=true"
import script from "./Licence.vue?vue&type=script&lang=ts"
export * from "./Licence.vue?vue&type=script&lang=ts"
import style0 from "./Licence.vue?vue&type=style&index=0&id=165c6f64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165c6f64",
  null
  
)

export default component.exports